import { useContext, useCallback, useState } from 'react';
import { UserProfileContext } from './getContext';
import { usePusherChannel } from './pusher.utills';

export const UseQuickNotifications = () => {
    const [quickNotifications, setQuickNotifications] = useState([]);
    const [quickNotificationsForCounter, setQuickNotificationsForCounter] = useState([]);

    const { profileData } = useContext(UserProfileContext) || {};

    const onMessage = useCallback((data) => {
        setQuickNotifications((pre) => [...pre, data]);
        setQuickNotificationsForCounter((pre) => [...pre, data]);
    }, []);
    usePusherChannel(
        profileData?.hasOwnProperty('id') && `private-Modules.User.Models.User.${profileData?.id}`,
        ['Illuminate\\Notifications\\Events\\BroadcastNotificationCreated'],
        { onMessage }
    );
    return { quickNotifications, quickNotificationsForCounter, setQuickNotificationsForCounter };
};
